export default __webpack_public_path__ + "static/media/07.4d9cc132.jpg";